/**
 * MemberCard component background color options.
 * Treat this file as an enum.
 * @module memberCardColorOptions
 * @category ChoirMembers
 * @author Dan Levy <danlevy124@gmail.com>
 */

/**
 * Secondary blue color
 */
export const SECONDARY_BLUE = "secondaryBlue";

/**
 * Green color
 */
export const GREEN = "green";

/**
 * Primary blue color
 */
export const PRIMARY_BLUE = "primaryBlue";

/**
 * Orange color
 */
export const ORANGE = "orange";

/**
 * Tertiary blue color
 */
export const TERTIARY_BLUE = "tertiaryBlue";

/**
 * Red color
 */
export const RED = "red";
